module.exports = __webpack_public_path__ + "img/31.eed127b7.png";